const MUTATIONS = {
  isStopScroll (state, payload) {
    state.isStopScroll = payload
  },
  isOpen (state, payload) {
    state.isOpen = payload
  }
}

export default MUTATIONS



// WEBPACK FOOTER //
// ./src/store/modules/ui/mutations.js